import React, { useState, useMemo, useEffect } from 'react';
import {
  Check,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownRoot,
  DropdownToggle,
  ThemeProvider,
} from '@alphonsocode/kallos';
import { DropDownStyle } from './style';
import CustomTooltip from '../Reusable/CustomTooltip';
import useQuery from 'reusable/customHooks/useQuery';
import { isString } from 'lodash';
import { track } from 'analytics/posthog';

export const toBoolean = str => str.toLowerCase() === 'true';

function DropDownComponent({
  isChecked,
  setIsChecked,
  selectedTestType,
  isMyTestsChecked,
  setIsMyTestsChecked,
}) {
  const [query, setQuery] = useQuery();
  const hideCampaignSelection = selectedTestType === 'ssp';
  useEffect(() => {
    if (isChecked) setQuery('myCampaigns', 'true');
    else setQuery('myCampaigns', 'false');
  }, [query]);

  const handleToggleChange = e => {
    setIsChecked(e);
    track('adsure my campaigns toggled', {
      enabled: Boolean(e),
      surface: 'adsure',
    });
    if (e) setQuery({ myCampaigns: 'true', page: '1' });
    else setQuery({ myCampaigns: 'false', page: '1' });
  };
  const handleMyTestToggleChange = e => {
    setIsMyTestsChecked(e);
    track('adsure my tests toggled', {
      enabled: Boolean(e),
      surface: 'adsure',
    });
    if (e) setQuery({ myTests: 'true', page: '1' });
    else setQuery({ myTests: 'false', page: '1' });
  };
  return (
    <DropDownStyle>
      <div className="dropdownDiv">
        <label className="heading">Select Campaigns</label>
        {/* @ts-ignore - ThemeProvider children type issue with React 18 */}
        <ThemeProvider defaultMode="light">
          <DropdownRoot modal={false}>
            {hideCampaignSelection ? (
              <CustomTooltip
                overlay="Campaign grouping is not supported for Programmatic SSP results."
              >
                <span>
                  <DropdownToggle
                    className="dropdownMain"
                    disabled={hideCampaignSelection}
                  >
                    Select Campaigns
                  </DropdownToggle>
                </span>
              </CustomTooltip>
            ) : (
              <DropdownToggle
                className="dropdownMain"
                disabled={hideCampaignSelection}
              >
                Select Campaigns
              </DropdownToggle>
            )}
            <DropdownMenu sideOffset={5}>
              {!hideCampaignSelection && (
                <DropdownItem onSelect={e => e.preventDefault()}>
                  {/* preventDefault is inportant to stop the dropdown from collapsing on click */}
                  <div className="checkbox-container">
                    <Check
                      variant="check"
                      checked={isChecked}
                      onCheckedChange={handleToggleChange}
                    />
                    <label className="checkboxText">My Campaigns</label>
                  </div>
                </DropdownItem>
              )}
              {selectedTestType === 'on-demand' && (
                <DropdownItem onSelect={e => e.preventDefault()}>
                  {/* preventDefault is inportant to stop the dropdown from collapsing on click */}
                  <div className="checkbox-container">
                    <Check
                      variant={'check'}
                      renderType="check"
                      checked={isMyTestsChecked}
                      onCheckedChange={handleMyTestToggleChange}
                    />
                    <label className="checkboxText">My Tests</label>
                  </div>
                </DropdownItem>
              )}
            </DropdownMenu>
          </DropdownRoot>
        </ThemeProvider>
      </div>
    </DropDownStyle>
  );
}

export default DropDownComponent;
